import { ApiCallConfig } from "routes/dashboard/ApiPlaygroundTypes";
import { CollectorType, NewProjectConfig } from "./types";
import { isSDEProject } from "sdecontent";

export const newProject = (userId: number, projectName: string|undefined, collectorType: CollectorType): NewProjectConfig => ({
  "userId": userId,
  "name": projectName || '',
  // scraping interval can't be empty, so let's use weekly
  'scrapingInterval': 'weekly',
  // Cron will be updated later
  "cron": "0 1 * * 1",
  "enabled": process.env.REACT_APP_SCHEDULING_ENABLED_BY_DEFAULT === 'true',
  // By default scheduling is disabled
  "supposedToRunAt": new Date(),
  "config": {
    "type": collectorType,
    "apiParams": {
      "outputFormat": isSDEProject(collectorType) ? 'json' : undefined,
    },
  },
  "input": {
    "type": "list_literal",
    "list": '',
  },
  "output": {
    "type": "save",
  },
  notificationConfig: {
    notifyOnSuccess: 'never',
    notifyOnFailure: 'with_every_run',
    notificationChanged: new Date(),
  },
  demoProject: false,
  schedulingIssue: undefined
});

export const newProjectFromApiCallConfig = (userId: number, projectName: string|undefined, apiCallConfig: ApiCallConfig): NewProjectConfig => ({
  "userId": userId,
  "name": projectName || '',
  // scraping interval can't be empty, so let's use weekly
  'scrapingInterval': 'weekly',
  // Cron will be updated later
  "cron": "0 1 * * 1",
  "enabled": process.env.REACT_APP_SCHEDULING_ENABLED_BY_DEFAULT === 'true',
  // By default scheduling is disabled
  "supposedToRunAt": new Date(),
  "config": apiCallConfig.config,
  "input": {
    "type": "list_literal",
    "list": apiCallConfig.input,
  },
  "output": {
    "type": "save",
  },
  notificationConfig: {
    notifyOnSuccess: 'never',
    notifyOnFailure: 'with_every_run',
    notificationChanged: new Date(),
  },
  demoProject: false,
  schedulingIssue: undefined
});
